import { render } from "./ValidationRuleEditor.vue?vue&type=template&id=1165072f&scoped=true"
import script from "./ValidationRuleEditor.vue?vue&type=script&lang=js"
export * from "./ValidationRuleEditor.vue?vue&type=script&lang=js"

import "./ValidationRuleEditor.vue?vue&type=style&index=0&id=1165072f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1165072f"]])

export default __exports__